import React, { useState } from 'react';
import { FaPlus, FaMinus, FaRedo } from 'react-icons/fa';

const SimpleCounter = () => {
  const [count, setCount] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const animateCount = () => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 200);
  };

  const increment = () => {
    setCount(prev => prev + 1);
    animateCount();
  };

  const decrement = () => {
    setCount(prev => prev - 1);
    animateCount();
  };

  const reset = () => {
    setCount(0);
    animateCount();
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Simple Counter
        </h3>

        {/* Counter Display */}
        <div className="mb-6">
          <div className={`text-6xl font-bold transition-all duration-200 ${
            isAnimating ? 'scale-110 text-blue-600 dark:text-blue-400' : 'text-gray-900 dark:text-white'
          }`}>
            {count}
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
            Current Count
          </p>
        </div>

        {/* Control Buttons */}
        <div className="flex justify-center space-x-4">
          <button
            onClick={decrement}
            className="flex items-center justify-center w-12 h-12 bg-red-500 hover:bg-red-600 text-white rounded-full transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg"
            title="Decrement"
          >
            <FaMinus className="text-lg" />
          </button>

          <button
            onClick={reset}
            className="flex items-center justify-center w-12 h-12 bg-gray-500 hover:bg-gray-600 text-white rounded-full transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg"
            title="Reset"
          >
            <FaRedo className="text-lg" />
          </button>

          <button
            onClick={increment}
            className="flex items-center justify-center w-12 h-12 bg-green-500 hover:bg-green-600 text-white rounded-full transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg"
            title="Increment"
          >
            <FaPlus className="text-lg" />
          </button>
        </div>

        {/* Stats */}
        <div className="mt-6 grid grid-cols-3 gap-4 text-center">
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3">
            <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              {count > 0 ? '+' : ''}{count}
            </div>
            <div className="text-xs text-blue-600 dark:text-blue-400">
              Total
            </div>
          </div>
          <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-3">
            <div className="text-2xl font-bold text-green-600 dark:text-green-400">
              {Math.max(0, count)}
            </div>
            <div className="text-xs text-green-600 dark:text-green-400">
              Positive
            </div>
          </div>
          <div className="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-3">
            <div className="text-2xl font-bold text-purple-600 dark:text-purple-400">
              {Math.abs(count)}
            </div>
            <div className="text-xs text-purple-600 dark:text-purple-400">
              Absolute
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleCounter;